import React from 'react';
import PropTypes from 'prop-types';
import PaymentFormStripe from '../../../reservation/containers/PaymentFormContainerStripe';
import Modal from '../../../components/Modal';
import ModalCloseButton from '../../../components/ModalCloseButton';
import LightLogo from '../../../components/LightLogo';

const CardInfoModal = props => (
  <Modal
    className="c-checkout-modal"
    close={props.off}
  >
    <ModalCloseButton onClick={props.off} />
    <div className="c-checkout-modal__header u-mb">
      <LightLogo />
    </div>
    <PaymentFormStripe
      confirmSetup={props.confirmSetup}
      title="Credit Card Information"
      buttonLabel="Update Information"
    />
  </Modal>
);

CardInfoModal.propTypes = {
  off: PropTypes.func.isRequired,
  confirmSetup: PropTypes.func.isRequired,
};

export default CardInfoModal;



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/components/CardInfoModal.jsx